import React, { Dispatch, SetStateAction } from 'react';
import { Switch, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../MyAppText';
import { Controller, UseFormReturn } from 'react-hook-form';

type Props = {
    label: string;
    direction: 'row' | 'column';
    disabled?: boolean;
    side?: 'left' | 'right';
    useEnhancedStyle?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: boolean;
    onChange: Dispatch<SetStateAction<boolean>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    onChange?: undefined;
});

function FilterSwitch({
    label,
    value,
    onChange,
    direction,
    disabled = false,
    side = 'left',
    useEnhancedStyle = false,
    form,
    fieldName
}: Props) {
    const { styles, theme } = useStyles(stylesheet);
    if (form && fieldName) {
        return <Controller
            control={form.control}
            name={fieldName}
            render={({ field }) => (
                <View style={styles.inputContainer(direction)}>
                    {side === 'left' && (
                        <MyAppText style={useEnhancedStyle ? styles.filterTextEnhanced : styles.filterText}>
                            {label}
                        </MyAppText>
                    )}
                    <Switch
                        trackColor={
                            useEnhancedStyle
                                ? { false: theme.colors.switch.unselectedTrack, true: theme.colors.switch.selectedTrack }
                                : { false: '#767577', true: '#81b0ff' }
                        }
                        // This is required because the lib does not declare this prop
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        activeThumbColor={
                            useEnhancedStyle
                                ? theme.colors.switch.background
                                : field.value
                                    ? '#f5dd4b'
                                    : '#f4f3f4'
                        }
                        thumbColor={
                            useEnhancedStyle
                                ? theme.colors.switch.background
                                : field.value
                                    ? '#f5dd4b'
                                    : '#f4f3f4'
                        }
                        onValueChange={field.onChange}
                        value={field.value}
                        disabled={disabled}
                    />
                    {side === 'right' && (
                        <MyAppText style={useEnhancedStyle ? styles.filterTextEnhanced : styles.filterText}>
                            {label}
                        </MyAppText>
                    )}
                </View>
            )}
        />;
    } else if (value !== undefined && onChange !== undefined) {
        return (
            <View style={styles.inputContainer(direction)}>
                {side === 'left' && (
                    <MyAppText style={useEnhancedStyle ? styles.filterTextEnhanced : styles.filterText}>
                        {label}
                    </MyAppText>
                )}
                <Switch
                    trackColor={
                        useEnhancedStyle
                            ? { false: theme.colors.switch.unselectedTrack, true: theme.colors.switch.selectedTrack }
                            : { false: '#767577', true: '#81b0ff' }
                    }
                    // This is required because the lib does not declare this prop
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    activeThumbColor={
                        useEnhancedStyle
                            ? theme.colors.switch.background
                            : value
                                ? '#f5dd4b'
                                : '#f4f3f4'
                    }
                    thumbColor={
                        useEnhancedStyle
                            ? theme.colors.switch.background
                            : value
                                ? '#f5dd4b'
                                : '#f4f3f4'
                    }
                    onValueChange={onChange}
                    value={value}
                    disabled={disabled}
                />
                {side === 'right' && (
                    <MyAppText style={useEnhancedStyle ? styles.filterTextEnhanced : styles.filterText}>
                        {label}
                    </MyAppText>
                )}
            </View>
        );
    }
}

const stylesheet = createStyleSheet(theme => ({
    inputContainer: (direction: 'row' | 'column') => ({
        flex: 1,
        flexDirection: direction,
        gap: 8,
        alignItems: 'center',
    }),
    filterText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        height: 25,
    },
    filterTextEnhanced: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.modal.subheader,
    }
}));

export default FilterSwitch;
